import type {Root} from "./types";

export const getNotifications = (state: Root) => state.notifications;
